import React from 'react';
import Header from './Header';
import Footer from './Footer';
import StickyCTA from './StickyCTA';
import WhatsAppWidget from './WhatsAppWidget';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <StickyCTA />
      <WhatsAppWidget />
    </div>
  );
};

export default Layout;